import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { initSentry } from './sentry';
import { logger } from './utils/logger';

// Global error handlers for debugging white screen issues
window.addEventListener('error', (event) => {
  logger.error('[Global Error]', event.error || event.message);
});

window.addEventListener('unhandledrejection', (event) => {
  logger.error('[Unhandled Promise Rejection]', event.reason);
});

// Initialize Sentry (async, doesn't block rendering)
initSentry().catch(logger.error);

try {
  const container = document.getElementById('root');
  if (!container) {
    throw new Error('Root element not found');
  }
  const root = createRoot(container);
  root.render(
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  );
  logger.log('[Main] App rendered successfully');
} catch (error) {
  logger.error('[Main] Failed to render app:', error);
  // Fallback: show error on screen
  document.body.innerHTML = `
    <div style="padding: 20px; font-family: system-ui;">
      <h1>App Failed to Load</h1>
      <p>Error: ${error instanceof Error ? error.message : String(error)}</p>
      <p>Please check the console for more details.</p>
    </div>
  `;
}